"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowPropertiesDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../../../base-utils/map-creator");
var table_row_properties_1 = require("../../../../../../core/model/tables/properties/table-row-properties");
var table_row_property_descriptor_1 = require("../../../../../../core/model/tables/properties/table-row-property-descriptor");
var destination_1 = require("../../../destination");
var property_destination_1 = require("../../../property-destination");
var height_unit_destination_1 = require("../../height-unit-destination");
var width_unit_destination_1 = require("../../width-unit-destination");
var table_row_alignment_destination_1 = require("./table-row-alignment-destination");
var table_row_cant_split_destination_1 = require("./table-row-cant-split-destination");
var table_row_conditional_formatting_destination_1 = require("./table-row-conditional-formatting-destination");
var table_row_grid_after_destination_1 = require("./table-row-grid-after-destination");
var table_row_grid_before_destination_1 = require("./table-row-grid-before-destination");
var table_row_header_destination_1 = require("./table-row-header-destination");
var table_row_hide_cell_mark_destination_1 = require("./table-row-hide-cell-mark-destination");
var TableRowPropertiesDestination = (function (_super) {
    tslib_1.__extends(TableRowPropertiesDestination, _super);
    function TableRowPropertiesDestination(data, row) {
        var _this = _super.call(this, data) || this;
        _this.row = row;
        return _this;
    }
    Object.defineProperty(TableRowPropertiesDestination.prototype, "elementHandlerTable", {
        get: function () {
            return TableRowPropertiesDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    TableRowPropertiesDestination.getThis = function (data) {
        return data.destinationStack.getThis();
    };
    TableRowPropertiesDestination.handlerTable = new map_creator_1.MapCreator()
        .add('cantSplit', function (data) { return new table_row_cant_split_destination_1.TableRowCantSplitDestination(data, TableRowPropertiesDestination.getThis(data).row); })
        .add('gridAfter', function (data) { return new table_row_grid_after_destination_1.TableRowGridAfterDestination(data, TableRowPropertiesDestination.getThis(data).row); })
        .add('gridBefore', function (data) { return new table_row_grid_before_destination_1.TableRowGridBeforeDestination(data, TableRowPropertiesDestination.getThis(data).row); })
        .add('hidden', function (data) { return new table_row_hide_cell_mark_destination_1.TableRowHideCellMarkDestination(data, TableRowPropertiesDestination.getThis(data).row); })
        .add('jc', function (data) { return new table_row_alignment_destination_1.TableRowAlignmentDestination(data, TableRowPropertiesDestination.getThis(data).row); })
        .add('tblCellSpacing', function (data) {
        var props = TableRowPropertiesDestination.getThis(data).row.properties;
        return new width_unit_destination_1.WidthUnitNonNegativeDestination(data, props.cellSpacing, function () { return props.setUseValue(table_row_properties_1.TableRowPropertiesMask.UseCellSpacing, true); });
    })
        .add('tblHeader', function (data) { return new table_row_header_destination_1.TableRowHeaderDestination(data, TableRowPropertiesDestination.getThis(data).row); })
        .add('trHeight', function (data) { return new height_unit_destination_1.HeightUnitDestination(data, TableRowPropertiesDestination.getThis(data).row.height); })
        .add('wBefore', function (data) { return new width_unit_destination_1.WidthUnitDestination(data, TableRowPropertiesDestination.getThis(data).row.widthBefore, function () { }); })
        .add('wAfter', function (data) { return new width_unit_destination_1.WidthUnitDestination(data, TableRowPropertiesDestination.getThis(data).row.widthAfter, function () { }); })
        .add('cnfStyle', function (data) { return new table_row_conditional_formatting_destination_1.TableRowConditionalFormattingDestination(data, TableRowPropertiesDestination.getThis(data).row); })
        .add('divId', function (data) { return new property_destination_1.PropertyDestination(data, function (value) {
        var valueAsInt = parseInt(value, 10);
        var webSettings = data.documentModel.webSettings;
        if (webSettings.id == valueAsInt && webSettings.isBodyMarginsSet())
            TableRowPropertiesDestination.getThis(data).row.properties.setValue(table_row_property_descriptor_1.TableRowPropertyDescriptor.divId, valueAsInt);
    }); })
        .get();
    return TableRowPropertiesDestination;
}(destination_1.ElementDestination));
exports.TableRowPropertiesDestination = TableRowPropertiesDestination;
